import { useQuery } from "@tanstack/react-query";
import { toast } from "sonner";
import ehjzleeInstance from "./ehjzleeInstance";
import config from "./config";
import { useTranslations } from "next-intl";
import { useRouter } from "next/navigation";

export const useGetPropById = (unitId: string) => {
  const router = useRouter();
  const t = useTranslations("unitPage");

  const q = useQuery({
    queryKey: ["unit", unitId],
    queryFn: async () => {
      try {
        const res = await ehjzleeInstance.get(`${config.props}/${unitId}`);
        return res.data?.property as Property;
      } catch (error: any) {
        if (error?.response.status) {
          toast.error(t("unitNotFound"));
          router.push("/");
          throw error;
        }
      }
    },
    enabled: !!unitId,
    retry: 2,
  });

  return q;
};
